import { HANDLE_MODAL_CONDITIONS, HANDLE_SNACKBAR } from "redux/TypeConstant";

const ModalConditionReducer = (
  state = {
    modalCondition: {
      show: false,
    
    },
  },
  action
) => { 
  switch (action.type) {
    case HANDLE_MODAL_CONDITIONS:
      return {
        ...state,
        modalCondition: {
          show: action.show,
         
        },
      };
    default:
      return state;
  }
};

export default ModalConditionReducer;
